const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_41fcd887-8ec6-40f9-b180-4549d29a6fe7/artifacts/b7ptqsyw_image.png";

export const Logo = ({ className = "h-8 w-auto", testId = "site-logo" }) => (
  <img
    src={LOGO_URL}
    alt="Agrovest Reality TV Show"
    className={className}
    data-testid={testId}
  />
);

export default Logo;
